<template>
  <b-card class="rt-plot-container" body-class="rt-plot-body">
    <vue-plotly
        :id="`${stream.data_table}--rt-plot`"
        :data="plotData" :layout="plotLayout"
        v-bind="plotOptions"
    >
    </vue-plotly>
  </b-card>
</template>

<script>
import _ from 'lodash';
import { Plotly as vPlotly } from 'vue-plotly';

export default {
  props: ['stream', 'dataStreaming', 'feedStarted'],
  components: {
    'vue-plotly': vPlotly,
  },
  data() {
    return {
      plotData: [],
      plotLayout: {},
      plotOptions: {},
      tracesObj: {},
      mergedTraces: {},
    };
  },
  watch: {
    feedStarted(value) {
      if (value === false) {
        this.plotData = [];
      }
    },
    dataStreaming(value) {
      if (_.has(value, 'time')) {
        const nonTime = _.omit(value, 'time');
        if (!_.isEmpty(nonTime)) {
          _.forIn(nonTime, (val, key) => {
            const plotTrace = _.find(this.plotData, ['name', key]);
            if (plotTrace) {
              plotTrace.y = val;
              plotTrace.x = value.time;
            } else if (value.time && val) {
              const trace = {
                x: value.time,
                y: val,
                name: key,
                mode: 'markers',
                type: 'scattergl',
                marker: {
                  size: 4,
                },
              };
              this.plotData.push(trace);
            }
          });
        }
      }
    },
  },
};
</script>

<style>
.rt-plot-body {
  padding: 0;
}

.rt-plot-container {
  border: none;
}
</style>
